import PropTypes from 'prop-types';
import React from 'react';
import { twMerge } from 'tailwind-merge';

const PricingPrice = ({ price, originalPrice = undefined, enterprise }) => {
    return (
        <div
            className={twMerge(
                'inline-flex mb-2 gap-2 text-neutral2-900',
                'mb-0 mt-0 text-[38px] leading-[46px]',
                enterprise && 'flex whitespace-pre-line h-auto text-[26px] leading-[30px]'
            )}
        >
            {!enterprise && (
                <span className={"flex flex-col justify-start text-[18px] leading-[36px]"}>
                    $
                </span>
            )}
            {typeof price === "number"
                ? <span className="font-medium">{price.toFixed(2)}</span>
                : <span className="font-semibold">{price}</span>
            }
            {originalPrice !== undefined && originalPrice != price && (
                <span className="text-[18px] leading-[38px] text-neutral2-500 line-through">
                    {originalPrice.toFixed(2)}
                </span>
            )}
        </div>
    );
};

PricingPrice.displayName = 'Pricing__Price';

PricingPrice.propTypes = {
    enterprise: PropTypes.bool,
    mods: PropTypes.object,
    price: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ])
};

export default PricingPrice;
